<template>
    <div>
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
        </div>
        <div class="main-container">
            <ul class="user-container">
                <li class="user-item" v-for="(userItem, index) in userList" :key="index">
                    <div class="user-item__avatar" :style="{backgroundImage: `url(${userItem.avatar})`}"></div>
                    <div class="user-item__name">{{userItem.userName}}</div>
                </li>
            </ul>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[44]"
                    :page-size="pagination.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getResourceStudentReadList,
        getResourceTeacherReadList
    } from '@/api/accounting/accounting';
    import baseMixin from '@/mixins/baseMixin.js';

    export default {
        name: "videoWatchList",
        mixins: [baseMixin],
        data() {
            return {
                type: this.$route.query.type,
                resourceId: this.$route.query.resourceId,
                schoolId: this.$route.query.schoolId,
                userList: []
            }
        },
        created() {
            this.pagination.pageSize = 44;
            if(this.type === 'student') {
                this.getResourceStudentReadListFunc();
            } else {
                this.getResourceTeacherReadListFunc();
            }
        },
        methods: {
            getResourceStudentReadListFunc() {
                getResourceStudentReadList({
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    resourceId: this.resourceId,
                    schoolId: this.schoolId,
                    searchTitle: ''
                })
                    .then(res => res.data)
                    .then(data => {
                        this.pagination.total = data.data.pagination.total;
                        this.pagination.pages = data.data.pagination.pages;
                        this.userList = data.data.dataList;
                    })
            },
            getResourceTeacherReadListFunc() {
                getResourceTeacherReadList({
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    resourceId: this.resourceId,
                    schoolId: this.schoolId,
                    searchTitle: ''
                })
                    .then(res => res.data)
                    .then(data => {
                        this.pagination.total = data.data.pagination.total;
                        this.pagination.pages = data.data.pagination.pages;
                        this.userList = data.data.dataList;
                    })
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                if(this.type === 'student') {
                    this.getResourceStudentReadListFunc();
                } else {
                    this.getResourceTeacherReadListFunc();
                }
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageNo = 1;
                this.pagination.pageSize = pageSize;
                if(this.type === 'student') {
                    this.getResourceStudentReadListFunc();
                } else {
                    this.getResourceTeacherReadListFunc();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 12%;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }
    .main-container {
        width: 1600px;
        min-height: 560px;
        margin-top: 72px;

    }
    .user-container {
        padding-left: 79px;
        padding-top: 20px;
        @include clearfix;
        .user-item {
            float: left;
            width: 120px;
            padding: 10px;
            border: 1px solid #20a0ff;
            box-sizing: border-box;
            margin-right: 17px;
            margin-bottom: 17px;
            .user-item__avatar {
                width: 100px;
                height: 100px;
                @include cover-bg;
            }
            .user-item__name {
                text-align: center;
            }
        }
    }
    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }
    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }
    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }
    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
    .pagination-container {
        text-align: right;
        width: 1320px;
        margin: 10px auto 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/videoWatchList.vue